import { baseApi } from "../baseApi";

const REGION_BASE_URL = "/regions";

export const regionApi = baseApi.injectEndpoints({
  tagTypes: ["Region"],

  endpoints: (builder) => ({
    getRegionList: builder.query({
      query: (params) => ({
        url: `${REGION_BASE_URL}/region-list`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({ type: "Region", id: _id })),
              { type: "Region", id: "LIST" },
            ]
          : [{ type: "Region", id: "LIST" }],
    }),

    getDistrictByRegionId: builder.query({
      query: (regionId) => ({
        url: `${REGION_BASE_URL}/district/${regionId}`,
        method: "GET",
      }),
      providesTags: (result, error, regionId) => [
        { type: "Region", id: `Region-${regionId}` },
        { type: "Region", id: "LIST" },
      ],
    }),

    getBranchesByRegionId: builder.query({
      query: (regionId) => ({
        url: `${REGION_BASE_URL}/region-branches/${regionId}`,
        method: "GET",
      }),
      providesTags: (result, error, regionId) => [
        { type: "Region", id: `RegionBranches-${regionId}` },
        { type: "Region", id: "LIST" },
      ],
    }),

    getDdlRegionList: builder.query({
      query: () => `${REGION_BASE_URL}/ddl`,
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "Region",
                _id,
              })),
              { type: "Region", id: "LIST" },
            ]
          : [{ type: "Region", id: "LIST" }],
    }),
    getDDLRestrictedRegionList: builder.query({
      query: (params) => ({ url: `${REGION_BASE_URL}/ddl-restricted`, params }),
      providesTags: [{ type: "Region", id: "DDL_RESTRICTED" }],
    }),

    getRegionDetail: builder.query({
      query: (id) => `${REGION_BASE_URL}/region-edit/${id}`,

      providesTags: (result, error, id) => [
        { type: "Region", id },
        { type: "Region", id: "LIST" },
      ],
    }),

    createRegion: builder.mutation({
      query: (payload) => ({
        url: `${REGION_BASE_URL}/region-create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "Region", id: "LIST" }],
    }),
    updateRegion: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${REGION_BASE_URL}/region-edit/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "Region", id: id },
        { type: "Region", id: "LIST" },
      ],
    }),
    updateRegionStatus: builder.mutation({
      query: ({ id, status }) => {
        return {
          url: `${REGION_BASE_URL}/${id}/status`,
          method: "PUT",
          body: { status },
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "Region", id },
        { type: "Region", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetRegionListQuery,
  useLazyGetRegionListQuery,
  useGetDdlRegionListQuery,
  useLazyGetDdlRegionListQuery,

  useLazyGetDDLRestrictedRegionListQuery,

  useGetDistrictByRegionIdQuery,
  useLazyGetDistrictByRegionIdQuery,

  useGetRegionDetailQuery,
  useCreateRegionMutation,
  useUpdateRegionMutation,
  useUpdateRegionStatusMutation,

  useGetBranchesByRegionIdQuery,
  useLazyGetBranchesByRegionIdQuery,
} = regionApi;
